import React from "react";
import { router } from "expo-router";
import LIcon from "./LIcon";
import LPressable from "@components/LPressable";

const ModalBackButton = () => {
  return (
    <LPressable sentryEventName="modal_back_button" onPress={router.back}>
      <LIcon
        sentryEventName="modal_back_button"
        name="chevron"
        rotate={90}
        size={22}
        stroke="white"
        paddingRight="l1"
        paddingVertical="s2"
      />
    </LPressable>
  );
};

export default ModalBackButton;
